import PortalIdParser from 'PortalIdParser';
import Comments from 'in-meeting-experience-ui-components/components/comments/Comments';
import { ErrorContext } from 'in-meeting-experience-ui-components/contexts/error/context';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { createComment, deleteComment, fetchComments, updateComment } from '../data/api/commentsApi';
import { fetchExternalOptions } from '../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../data/api/snippetsApi';
import useTracker from '../hooks/useTracker';
import { hubspotUserIdSelector, prosemirrorTrackerPropertiesSelector } from '../slices/auth/selectors';
import { callObjectIdSelector } from '../slices/callObject/selectors';
import { isPreviousMeetingsMenuOpenSelector } from '../slices/recurringMeetings/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
function CommentsComponent() {
  const {
    showError
  } = useContext(ErrorContext);
  const hubspotUserId = useSelector(hubspotUserIdSelector);
  const callObjectId = useSelector(callObjectIdSelector);
  const isPreviousMeetingsMenuOpen = useSelector(isPreviousMeetingsMenuOpenSelector);
  const prosemirrorTrackerProperties = useSelector(prosemirrorTrackerPropertiesSelector);
  const usageTracker = useTracker();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "COMMENTS_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Comments, {
      portalId: PortalIdParser.getPortalIdFromPath(),
      hubspotUserId: hubspotUserId || 0,
      callObjectId: Number(callObjectId),
      isStickyFooterHidden: isPreviousMeetingsMenuOpen || showError,
      usageTracker: usageTracker,
      apiWrapper: {
        getComments: fetchComments,
        createComment,
        deleteComment,
        updateComment,
        fetchOwners: fetchExternalOptions,
        snippets: {
          fetchRenderedContent,
          fetchUnrenderedContent,
          searchSnippets
        }
      },
      prosemirrorTrackerProperties: prosemirrorTrackerProperties
    })
  });
}
export default CommentsComponent;